import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-admin-client',
  templateUrl: './admin-client.component.html',
  styleUrls: ['./admin-client.component.less'],
  providers: [SharedDataService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientComponent {
  constructor(
    private SharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private ToastService: ToastService
  ) {
    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const CompanyId = Number(ParamMap.get('CompanyId'));

        if (!CompanyId) {
          throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
            returnError: true
          });
        }

        Object.assign(this, { CompanyId });
      }
    });

    this.SharedDataService.listenForEvent<string>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'GetCompanyId') {
          this.SharedDataService.sendEvent('SetCompanyId', this.CompanyId);
        }

        if (eventName === 'SetTitle' && typeof data === 'string') {
          this.title = data;
        }
      }
    });
  }

  CompanyId!: number;
  title: string = '';
}
